import { Checkbox, Container, Loader, Text } from "@mantine/core";
import ApartmentCard from "components/ApartmentCard.jsx";
import GridContainer from "components/GridContainer.jsx";
import { useTrans } from "core/index.js";
import React from "react";
import { useNavigate } from "react-router";
import apiService from "services/ApiService.js";
import getLocalizedField from "services/getLocalizedField.js";
import { Api_Apartment, Api_GetUnPublished } from "../../../../constants/SubApi.js";

export default function Unpublished() {
	const [loading, setLoading] = React.useState(true);
	const [apartments, setApartments] = React.useState([]);
	const [includeDenied, setIncludeDenied] = React.useState(false);
	const navigate = useNavigate();
	const { t } = useTrans();

	React.useEffect(() => {
		let mounted = true;

		async function init() {
			setLoading(true);
			try {
				const filter = JSON.stringify({ denied: includeDenied });
				const res = await apiService.get(`/${Api_Apartment}/${Api_GetUnPublished}?filter=${filter}`);

				if (mounted && res?.data) {
					setApartments(res.data);
				}
			} catch (er) {
				console.warn("failed to load apartments", er);
			} finally {
				if (mounted) setLoading(false);
			}
		}

		init();

		return () => {
			mounted = false;
		};
	}, [includeDenied]);

	return (
		<Container size="xl" style={{ padding: 12 }}>
			<Checkbox
				label={t("customApartment.denied")}
				checked={includeDenied}
				onChange={(e) => setIncludeDenied(e.currentTarget.checked)}
				mb={16}
			/>

			{loading && (
				<div style={{ padding: 32, textAlign: "center" }}>
					<Loader size="xl" color="blue" />
				</div>
			)}

			{!loading && !apartments.length && <Text>{t("messages.noDataFound")}</Text>}

			{!loading && apartments.length > 0 && (
				<GridContainer>
					{apartments.map((apt) => (
						<ApartmentCard
							key={apt.id}
							title={getLocalizedField(apt, "name")}
							desc={getLocalizedField(apt, "desc")}
							currency={getLocalizedField(apt, "currency_name")}
							price={apt.dailyPrice}
							image={apt.baseImage}
							rating={apt.evaluate || 0}
							status={apt.status}
							onClick={() => navigate(`/apartments/publish/${apt.id}`)}
						/>
					))}
				</GridContainer>
			)}
		</Container>
	);
}
